/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForGcpBillingAccount extends models.ServiceAccountNativeDetailsBaseForGcp {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForGcpBillingAccount");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForGcpBillingAccount.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForGcpBillingAccount>): ServiceAccountNativeDetailsForGcpBillingAccount {
        let obj = Object.assign(new ServiceAccountNativeDetailsForGcpBillingAccount(), model);
        ServiceAccountNativeDetailsForGcpBillingAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForGcpBillingAccount>): ServiceAccountNativeDetailsForGcpBillingAccount {
        if (!model) return null;
        return ServiceAccountNativeDetailsForGcpBillingAccount.newInstance(<ServiceAccountNativeDetailsForGcpBillingAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForGcpBillingAccount) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForGcpBillingAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForGcpBillingAccount): boolean {
        if (models.ServiceAccountNativeDetailsBaseForGcp.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForGcpBillingAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Billing Account Id
     */
    billing_account_id: string;

}
